var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isExclude ? 'task-header excluded' : 'task-header'},[_vm._v(" Task: "+_vm._s(_vm.taskName)+" "),(_vm.enableExcludeItems)?_c('b-checkbox',{on:{"input":_vm.onItemToExclude},model:{value:(_vm.isExclude),callback:function ($$v) {_vm.isExclude=$$v},expression:"isExclude"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }